import React, { useCallback, useMemo, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import MediaService from '../../services/MediaService'
import { sleep } from '../../utils'
import './WorldChooseReward.scss'

const WorldChooseReward = ({
	module,
	moduleName,
	onRewardSelectionEnd,
	rewardOption1,
	rewardOption2,
}) => {
	const { login } = useSelector((state) => state.loginReducer, shallowEqual)

	const greenCheckSound = MediaService.getVideo(
		'/Module1Videos/button_accept_item.mp3',
		login
	)
	const buttonTouch = MediaService.getVideo(
		'/Module1Videos/touch_button.mp3',
		login
	)
	const openSound = MediaService.getVideo(
		'/Module1Videos/oepn_chest.wav',
		login
	)
	const greenCheck = MediaService.getImage(
		'/Module1Images/GreenCheck-Button.png',
		login
	)

	const dispatch = useDispatch()
	const [touchButton, setTouchButton] = useState(false)
	const [buttonTouchAudio, setTouchButtonAudio] = useState('')
	const [displayGreenButton, setDisplayGreenButton] = useState(false)
	const [checkSound, setCheckSound] = useState(false)
	const [selectedReward, setSelectedReward] = useState(null)

	const handleRewardClick = useCallback(
		(position) => {
			const sound = new Audio(buttonTouch)
			sound.play()
			setSelectedReward(position === 'left' ? rewardOption1 : rewardOption2)

			dispatch({
				type: `${moduleName}_SET_REWARD${module.currentday}1`,
				payload: position === 'left',
			})

			dispatch({
				type: `${moduleName}_SET_REWARD${module.currentday}2`,
				payload: position === 'right',
			})
			setDisplayGreenButton(true)
		},
		[
			buttonTouch,
			dispatch,
			module.currentday,
			moduleName,
			rewardOption1,
			rewardOption2,
		]
	)

	// The game details are initially loaded here. This sets up the module
	const createGameDetails = useCallback(
		(flag, reward) => {
			const { game_details } = module

			if (flag) {
				const flags = { flag, lastUpdated: new Date().toJSON() }
				game_details.moduleFlags.push(flags)
			}

			if (reward) {
				const dailyRewards = []

				for (const key in module.rewards) {
					if (module.rewards[key]) {
						const rewards = { type: key, x_multiplier: 1, y_multiplier: 1 }
						dailyRewards.push(rewards)
					}
				}

				game_details.dailyRewards = dailyRewards
			}

			dispatch({
				type: `${moduleName}_SET_GameDetails`,
				payload: game_details,
			})
		},
		[dispatch, module, moduleName]
	)

	const handleCheckClick = useCallback(async () => {
		setCheckSound(true)
		setDisplayGreenButton(false)
		await sleep(500)
		createGameDetails(false, true)
		onRewardSelectionEnd()
	}, [createGameDetails, onRewardSelectionEnd])

	const RewardButtonComponent = React.forwardRef(
		({ src, id, onChooseReward }, ref) => {
			return (
				<button
					onClick={(event) => onChooseReward(event)}
					className={`reward-item-btn ${
						selectedReward === src ? 'active' : null
					}`}
					style={{ backgroundImage: `url(${src})` }}
				></button>
			)
		}
	)
	RewardButtonComponent.displayName = 'RewardButtonComponent'

	return (
		<>
			<audio autoPlay>
				<source src={openSound}></source>
			</audio>

			{touchButton && (
				<audio autoPlay onEnded={() => setTouchButton(false)}>
					<source src={buttonTouchAudio} type="audio/mp3" />
				</audio>
			)}

			{checkSound && (
				<audio autoPlay onEnded={() => setCheckSound(false)}>
					<source src={greenCheckSound} type="audio/mp3" />
				</audio>
			)}

			{useMemo(
				() => (
					<div className={`reward-options ${moduleName}`}>
						<RewardButtonComponent
							src={rewardOption1}
							onChooseReward={(ev) => handleRewardClick('left')}
						/>

						<RewardButtonComponent
							src={rewardOption2}
							onChooseReward={(ev) => handleRewardClick('right')}
						/>
					</div>
				),
				[handleRewardClick, moduleName, rewardOption1, rewardOption2]
			)}

			<div className="reward-check-container">
				{displayGreenButton && (
					<button
						className="reward-check-btn"
						onClick={() => handleCheckClick()}
					>
						<img src={greenCheck} alt="check mark" />
					</button>
				)}
			</div>
		</>
	)
}

export default WorldChooseReward
